var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "catalog",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11776",
    "data-name": "Path 11776",
    d: "M16.864,2H6.339A1.169,1.169,0,0,0,5.169,3.169V5.508H4V6.678H5.169V9.6H4v1.169H5.169v2.924H4v1.169H5.169V17.2a1.169,1.169,0,0,0,1.169,1.169H16.864A1.169,1.169,0,0,0,18.033,17.2V3.169A1.169,1.169,0,0,0,16.864,2Zm0,15.2H6.339V14.864H7.508V13.694H6.339V10.771H7.508V9.6H6.339V6.678H7.508V5.508H6.339V3.169H16.864Z",
    transform: "translate(-1.661 -0.831)",
    fill: "#0a6ed1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5157",
    "data-name": "Rectangle 5157",
    width: 5,
    height: 1,
    transform: "translate(8 5)",
    fill: "#0a6ed1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5158",
    "data-name": "Rectangle 5158",
    width: 5,
    height: 1,
    transform: "translate(8 9)",
    fill: "#0a6ed1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5159",
    "data-name": "Rectangle 5159",
    width: 5,
    height: 1,
    transform: "translate(8 13)",
    fill: "#0a6ed1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.05e78f10331de02e3ca9a40f42b91fb6.svg";
export { ForwardRef as ReactComponent };